import { render, staticRenderFns } from "./purchaseLinkDialog.vue?vue&type=template&id=5fb479a3&scoped=true&"
import script from "./purchaseLinkDialog.vue?vue&type=script&lang=js&"
export * from "./purchaseLinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./purchaseLinkDialog.vue?vue&type=style&index=0&id=5fb479a3&prod&lang=scss&scoped=true&"
import style1 from "./purchaseLinkDialog.vue?vue&type=style&index=1&id=5fb479a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb479a3",
  null
  
)

export default component.exports